






















import { Component } from 'vue-property-decorator'
import { FilterCondition, FilterType } from '@/module/graphql'
import BaseFieldFilter from './base-field-filter'
import _ from 'lodash'
import util from '@/d2admin/libs/util'

@Component
export default class StringArrayFilter extends BaseFieldFilter {
  private mValueDisabled: boolean = false
  private operators = [
    'like', 'contains', 'empty'
  ]

  public initFilterCondition(filterCondition: FilterCondition) {
    if (!filterCondition.operator) filterCondition.operator = 'like'
    if (_.isNil(filterCondition.value)) filterCondition.value = ''
    util.objects.reactive(filterCondition)
  }

  public updateFilterType(operator: string) {
    if (operator === 'empty') {
      this.filterCondition.filterType = FilterType.IsNull
      this.mValueDisabled = true
      this.internalOnFilterChanged()
    } else {
      this.filterCondition.filterType = FilterType.Array
      this.mValueDisabled = false
    }
  }

  onOperatorChanged(operator: string) {
    this.updateFilterType(operator)
    if (this.filterCondition.value) this.internalOnFilterChanged()
  }

  clearContent() {
    this.filterCondition.operator = 'like'
    this.filterCondition.value = null
    this.internalOnFilterChanged()
  }
}
